import { DateFormats, FileTypesIcons } from '@constants';
import { FileIdResponse } from '@innowise-group/core';
import { Icon, IconProps } from '@innowise-group/mui-kit';
import { calculateDateWithTimeZone } from '@innowise-group/utilities';
import { format } from 'date-fns';
import React from 'react';
import { useTranslation } from 'react-i18next';

import * as Styled from './file-item.styles';

interface FileItemProps {
  file: FileIdResponse;
  onClick?: () => void;
  onDelete?: (event: React.MouseEvent<HTMLOrSVGElement>) => void;
  showDelete?: boolean;
  disabled?: boolean;
  icon?: IconProps['type'];
  showLock?: boolean;
}

const FileItem: React.FC<FileItemProps> = ({
  file,
  onClick,
  onDelete,
  showDelete = false,
  disabled = false,
  icon,
  showLock = file.secured,
}) => {
  const { t } = useTranslation();
  const fileIcon = icon || FileTypesIcons[file.filename.split('.').reverse()[0].toLowerCase()] || 'u_wrong_file';
  const hasActions = showLock || showDelete;

  return (
    <Styled.FileItem disabled={disabled} onClick={!disabled ? onClick : undefined} hasActions={hasActions}>
      <Styled.FileTitle>
        <Icon type={fileIcon} />
        <Styled.FileInfo>
          <Styled.FileName>{file.filename}</Styled.FileName>
          {file.createdDate && (
            <Styled.FileDate>
              {t('pages.candidates.offer.fileUploaded')}{' '}
              {format(calculateDateWithTimeZone(file.createdDate), DateFormats.TimeAndDayFirst)}
            </Styled.FileDate>
          )}
          {file.createdBy && <Styled.FileAuthor>{file.createdBy}</Styled.FileAuthor>}
        </Styled.FileInfo>
      </Styled.FileTitle>
      {hasActions && (
        <Styled.IconsContainer>
          {showLock && <Styled.LockIcon type="u_lock_alt" />}
          {showDelete && <Styled.DeleteIcon type="u_plus" onClick={onDelete} />}
        </Styled.IconsContainer>
      )}
    </Styled.FileItem>
  );
};

export default React.memo(FileItem);
